import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class ApplicantReview extends ApplicationRecord {
  static jsonapiType = "applicant_reviews";

  @Attr() averageOutOfOneHundred: number;

  @Attr() candidateFirstName: string;

  @Attr() communication: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() employerName: string;

  @Attr() jobTitle: string;

  @Attr() professionalism: number;

  @Attr() published: boolean;

  @Attr() message: string;

  @Attr() recommend: number;

  @Attr() recruiterId: number;

  @Attr() recruiterName: string;

  @Attr() recruiterUserFullName: string;

  @Attr() support: number;
}

export default ApplicantReview;
